import styled from 'styled-components';

export const NotificationsContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  margin-left: -290px;
  z-index: 9999;
`;
